var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageView',{attrs:{"title":"专项整治通知修改"}},[_c('template',{slot:"action"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.add}},[_vm._v("保存")])],1),_c('ExpertYearAssessForm',{ref:"evectionForm"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }